import { useMutation } from 'react-query';
import {useWordPressStore} from "../../store/wordpress.store";
import {WordpressApi} from "../../api/wordpress.api";

export const useWordPressVideos = () => {
    const setVideos = useWordPressStore((state) => state.setVideos);

    return useMutation(WordpressApi.getVideos, {
        onSuccess: (data) => {
            setVideos(data);
        },
        onError: (error) => {
            console.error('Login failed:', error);
        },
    });
};